<template>
  <div class="profile-page div p-l-50">
    <el-row class="p-b-100" type="flex" justify="center">
      <el-col :span="24">
        <el-tabs v-model="activeTab"  tab-position="top" style="height: 200px;">
          <!-- Хувийн мэдээлэл -->
          <el-tab-pane label="Profile" name="Profile" class="tab_pane_item">
            <span slot="label" >
              <i class="el-icon-user-solid"></i>
              Хувийн мэдээлэл
            </span>
            <el-row>
              <el-col>
                <h2>Хувийн мэдээлэл</h2>
              </el-col>
              <el-col class="m-t-10">
                <el-form :model="userDetailGetter">
                  <el-row class="tab_pane_item">
                    <el-col :xs="20" :sm="20" :md="10" :lg="10" :xl="10">
                      <el-form-item>
                        <span>Овог: </span>
                        <el-input v-model="userDetailGetter.ovog" :disabled="true" placeholder="Хоосон"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="20" :sm="20" :md="10" :lg="10" :xl="10">
                      <el-form-item>
                        <span>Нэр: </span>
                        <el-input v-model="userDetailGetter.name" :disabled="true" placeholder="Хоосон"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="20" :sm="20" :md="10" :lg="10" :xl="10">
                      <el-form-item>
                        <span>Нас: </span>
                        <el-input v-model="userDetailGetter.age" :disabled="true" placeholder="Хоосон"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="20" :sm="20" :md="10" :lg="10" :xl="10">
                      <el-form-item>
                        <span>Утас: </span>
                        <el-input v-model="userDetailGetter.phone" :disabled="true" placeholder="Хоосон"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="20" :sm="20" :md="10" :lg="10" :xl="10">
                      <el-form-item>
                        <span>Ажилладаг байгууллага: </span>
                        <el-input v-model="userDetailGetter.organization_name" :disabled="true" placeholder="Хоосон"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="20" :sm="20" :md="10" :lg="10" :xl="10">
                      <el-form-item>
                        <span>Цол: </span>
                        <el-input v-model="userDetailGetter.tsol" :disabled="true" placeholder="Хоосон"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="20" :sm="20" :md="10" :lg="10" :xl="10">
                      <el-form-item>
                        <span>Хүйс: </span>
                        <el-input v-model="userDetailGetter.gender" :disabled="true" placeholder="Хоосон"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="20" :sm="20" :md="10" :lg="10" :xl="10">
                      <el-form-item>
                        <span>Оролцон жин: </span>
                        <el-input v-model="userDetailGetter.weight" :disabled="true" placeholder="Хоосон"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col>
                      <el-button class="see_button" size="mini" @click="logout()">Гарах</el-button>
                    </el-col>
                  </el-row>
                </el-form>
              </el-col>
            </el-row>
          </el-tab-pane>
          <!-- Захиалгийн түүх -->
          <el-tab-pane label="Order" name="Order" class="tab_pane_item">
            <span slot="label" >
            <i class="el-icon-tickets"></i>
              Захиалгийн түүх
            </span>
            <el-row>
              <el-col>
              <h2>Захиалгийн түүх</h2>
            </el-col>
              <el-col>
                <!-- {{ orderList }} -->
                <!-- <el-form v-for="(item, index) in orderList" :key="index">
                  <el-row :span="24">
                    <el-col :span="20">
                      <el-form-item >
                        <span>Захиалгийн код: </span>
                        <el-input v-model="item.id" :disabled="true" placeholder="Хоосон"></el-input>
                          <button class="see_button" @click="openOrderDetailDialog(scope.row.id)">Харах</button>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form> -->
                <el-collapse v-model="activeNames" @change="handleChange" v-for="item,index in this.orderList" :key="index">
                  <el-collapse-item :title="item.id" name="1">
                    <h4><u>Захиалгийн дугаар</u> : {{ item.order_number }}</h4>
                    <h4><u>Утасны дугаар</u> : {{ item.order_number }}</h4>
                    <h4><u>Нийт дүн</u> : {{ item.total_amount | formatCurrency }}</h4>
                    <h4><u>Захиалсан огноо</u> : {{ item.created_at}}</h4>
                    <h4 v-if="item.order_status === 100"><u>Төлөв</u> : Хүргэгдсэн</h4>
                    <h4 v-if="item.order_status === 60"><u>Төлөв</u> : Жолоочид хувиарласан</h4>
                    <h4 v-if="item.order_status === 40"><u>Төлөв</u> : Шинэ захиалга</h4>
                    <h4 v-if="item.order_status === 10"><u>Төлөв</u> : Цуцлагдсан</h4>
                  </el-collapse-item>
                </el-collapse>
              </el-col>
            </el-row>
          </el-tab-pane>
          <!-- Тэмцээн -->
          <!-- <el-tab-pane >
            <span slot="label" >
             <i class="el-icon-truck"></i>
               Захиалгийн явц
            </span>
          </el-tab-pane> -->
        </el-tabs>
      </el-col>
    </el-row>
    <el-dialog :visible.sync="this.$root.orderDetailDialog" :before-close="handleClose">
      <el-form></el-form>
    </el-dialog>
  </div>
</template>
<script>
import services from '@/helpers/services.js'
import {
  mapGetters
} from 'vuex'
export default {
  data () {
    return {
      activeTab: 'Profile',
      activeName: 'Profile',
      orderList: [],
      activeNames: ['1']
    }
  },
  computed: {
    ...mapGetters([
      'userDetailGetter'
    ])
  },
  created () {
    this.getUserOrderHistory()
  },
  watch: {
    activeTab () {
      if (this.activeTab === 'Order') {
        console.log('hvselt')
      }
    }
  },
  methods: {
    logout () {
      localStorage.clear()
      location.reload()
      this.$router.push({
        path: '/login'
      })
    },
    getUserOrderHistory () {
      console.log(this.activeTab)
      // if (data === this.activeTab) {
      services.getUserOrderHistory()
        .then((response) => {
          this.orderList = response.result
          // this.loading = false
        })
      // }
    },
    openOrderDetailDialog (data) {
      const payload = {
        id: data.id
      }
      services.orderDetail(payload)
        .then((response) => {
          if (response.status === 'success') {
            this.$store.dispatch('addCategories', response.result)
          }
        })
      this.$root.fullscreenLoading = true
    },
    handleClose () {
      this.$root.orderDetailDialog = false
    },
    handleChange (val) {
      console.log(val)
    }
  }
}
</script>

<style>
  .tabsapce{
    margin-top: -100px;
  }
  .heit{
    height: 100px;
  }
  .see_button{
    background-color: black;
    color: white;
    border-radius: 5px;
  }
  .tab_pane_item{
    height: 800px;
  }
  @media all and (min-width: 991px) {
    .div {
      margin-left: 250px;
    }
  }
  @media all and (min-width: 768px) {
    .div {
      margin-left: 120px;
    }
  }
  @media all and (min-width: 576px) {
    .div {
      margin-left: 70px;
    }
  }

</style>
